export const getDisplayData = (team) => {
    return {
        id: team?.id ? team?.id : 0,
        name: team?.name ? team?.name : 'No name specified',
        description: team?.description ? team?.description : 'No description specified',
    };
};

// temp solution to mock drill down data after component generation - data may not exist
// makes it easy to clean up mock data and use real data when available (just search for this functions usage)
export const getMockDrillDownData = () => {
    return [{ id: '2578cb65923bb7ba0845014820190617', name: 'fake member number 1', description: 'description number 1' }, { id: '9876cb65923bb7ba0845014820190617', name: 'fake member number 2', description: 'description number 2' }];
};





// WEBPACK FOOTER //
// ./services/teamService.js